var UrlUtils;
(function(UrlUtils2) {
  UrlUtils2.origin = (fullurl) => {
    return new URL(fullurl).origin;
  };
  UrlUtils2.toUrl = (fullUrl) => {
    return new URL(fullUrl);
  };
  UrlUtils2.getUrlPath = (url) => {
    if (typeof url === "string") {
      try {
        const u = new URL(url, "http://localhost");
        return u.pathname + u.search;
      } catch (e) {
        return url;
      }
    }
    return (url.pathname ?? "") + (url.search ?? "");
  };
  UrlUtils2.deleteSearchParam = (searchParams, name) => {
    const names = Array.isArray(name) ? name : [name];
    names.forEach((n) => searchParams.delete(n));
    return searchParams;
  };
  UrlUtils2.appendSearchParam = (searchParams, params) => {
    params.forEach(([key, value]) => searchParams.append(key, value));
    return searchParams;
  };
  UrlUtils2.upsertSearchParam = (searchParams, params) => {
    Object.entries(params).forEach(([key, value]) => {
      searchParams.delete(key);
      if (Array.isArray(value)) {
        value.forEach((v) => searchParams.append(key, v));
      } else {
        searchParams.append(key, value);
      }
    });
    return searchParams;
  };
  UrlUtils2.toAbsoluteUrl = (relative, base) => {
    return new URL(relative, base);
  };
  function toAbsoluteRequest(input, base) {
    if (input instanceof URL) {
      return UrlUtils2.toAbsoluteUrl(input.href, base);
    }
    if (typeof input === "string") {
      return UrlUtils2.toAbsoluteUrl(input, base).href;
    }
    return new Request(UrlUtils2.toAbsoluteUrl(input.url, base).href, input);
  }
  UrlUtils2.toAbsoluteRequest = toAbsoluteRequest;
  UrlUtils2.manipulateSearchParams = (searchParams, options) => {
    if (options?.delete) {
      UrlUtils2.deleteSearchParam(searchParams, options.delete);
    }
    if (options?.append) {
      UrlUtils2.appendSearchParam(searchParams, options.append);
    }
    if (options?.upsert) {
      UrlUtils2.upsertSearchParam(searchParams, options.upsert);
    }
    return searchParams;
  };
})(UrlUtils || (UrlUtils = {}));
export {
  UrlUtils
};
//# sourceMappingURL=UrlUtils.js.map
